import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaInstagram,
} from "react-icons/fa";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div
      className="w-full overflow-hidden"
      style={{
        width: "100%",
        position: "absolute",
        left: 0,
        right: 0,
      }}
    >
      <footer className="w-full bg-[#398494] py-4">
        <div
          className="w-full mx-auto flex flex-col md:flex-row justify-center items-center text-white text-sm font-medium gap-5"
          style={{ paddingLeft: "2.5%", paddingRight: "2.5%" }}
        >
          <b>{t("home.copyright")}</b>

          <div className="flex items-center gap-1">
            <FaPhone />
            <span>+1 (407) 385-9794</span>
          </div>

          <div className="flex items-center gap-1">
            <FaEnvelope />
            <span>support@alpha-translations.com</span>
          </div>

          <div className="flex items-center gap-1">
            <FaMapMarkerAlt />
            <span>Orlando, FL, EUA</span>
          </div>

          <div className="flex items-center gap-1">
            <FaInstagram />
            <a
              href="https://www.instagram.com/alpha.translations"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              @alpha.translations
            </a>
          </div>

          <Link to="/terms-of-use" className="hover:underline">
            {t("common.termsOfUse")}
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
